import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { PublicAppInfo } from '@oca/web-shared';
import { selectAppInfo } from '../app.selectors';

@Component({
  selector: 'web-navbar',
  templateUrl: './web-navbar.component.html',
  styleUrl: './web-navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatToolbar,
    TranslatePipe,
  ],
})
export class WebNavbarComponent {
  appInfo: Signal<PublicAppInfo | null> = inject(Store).selectSignal(selectAppInfo);
}
